import type { PermissionAction } from "@protein/core-vue3/helpers/securityTypes"
import { Permission, useUserStore } from "@/stores/user-store"

export const canAccess = (resource: string, action: PermissionAction): boolean => {
  const store = useUserStore()

  const permission = store.user.permissions.filter((item: any) => item.code === resource)[0] || null
  let result = false
  if (permission !== null) {
    result = (permission.action & action) === action
  }
  return result
}

export const checkAccess = (resource: string, action: PermissionAction, permissions: Permission[]): boolean => {
  const permission = permissions.filter((item: any) => item.code === resource)[0] || null
  let result = false
  if (permission !== null) {
    result = (permission.action & action) === action
  }
  return result
}
